import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';
import { ContactTypeConstants } from '../../../common/constants/contact-type.constants';
import { ContactTypeValue } from '../../../common/enums/contact-type.value.enum';
import { Member } from '../../../shared/interface/member.interface';
import { CommonService } from '../../../shared/services/common.service';
import { MessageService } from '../../../shared/services/message.service';
import { CustomValidators } from '../../../shared/Utils/custom-validator';
import { Utils } from '../../../shared/Utils/utils';
import { CountryLevelValidations } from '../../constants/country-level-validations.interface';
import { DateConstants } from '../../constants/date.constants';
import { PersonalInfoFormConstants } from '../../constants/personal-info-form-property.constants';
import { ResponseStatus } from '../../constants/response-status-constants';
import { ValidateDateOfBirth } from '../../directive/validate-dob';
import { ContactPreferenceType } from '../../enums/contact-preference-type.enum';
import { MemeberCommunicationPreferenceValue } from '../../enums/member-communication-preference-value.enum';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { PersonalInfoMemberTitle } from '../../enums/personal-info-title.enums';
import { ControlsConfig, PersonalInformation, VerifyAccountResponse } from '../../interface/enrollment';
import { PersonalInfoFormFields } from '../../interface/enrollment/personal-info-form-fields.interface';
import { PersonalInfoConfig } from '../../interface/personal-info-config.interface';
import { PersonalInfoTitleConfig } from '../../interface/personal-info-title.interface';
import { EnrollmentMessageService } from '../../services/enrollment-message.service';
import { EnrollService } from '../../services/enrollment.service';
import { PersonalInfoTitleConfigService } from '../../services/persoanl-info-title-config.service';
import { PersonalInfoConfigService } from '../../services/personal-info-config.service';
import { CheckoutConfigService } from '../../services/checkout-config.service';
/**
 * @description  Used to Save Enroll
 * User Information and Edit User information
 * @date 2018-07-24
 * @export
 * @class PersonalInfoComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'app-personalinfo',
    templateUrl: '../../templates/template1/views/enrollment/personal-info.component.html',
    styleUrls: ['../../templates/template1/themes/default/css/guest-personal-info.component.less']
})

export class PersonalInfoComponent implements OnInit, OnDestroy {
    formSubmitted: boolean;
    mailAlreadyExist: boolean;
    guestUser: boolean;
    enrollmentInProgress = false;
    personalInfoFormValidated: boolean;
    personalInformationForm: FormGroup;
    personalInformation: PersonalInformation;
    personalInfoSubscription: Subscription;
    clearFormSubscription: Subscription;
    isEmailAlreadyExistsSubscription: Subscription;
    verifyEmailAccountInProgess = false;
    isShowLoader = false;
    phoneNumberAlreadyExists: boolean;
    isShowPhoneNumberLoader = false;
    personalInfoFormFields: PersonalInfoFormFields;
    phoneNumberFormat: string;
    contactTypes: any[] = [];
    isLegacyUser = false;
    intialPollCount = 0;
    maxPollCount = environment.longPollCount;
    userInfo: Member;
    personalInfoFormValid: boolean;
    personalInfoFormValidations: PersonalInfoFormFields;
    externalEmail: boolean;
    externalFboId: String;
    datePickerStartDateAt = new Date();
    personalInfoConfig: PersonalInfoConfig;
    enableDOBField: boolean;
    maxDate: Date;
    personalInfoTitleConfig: PersonalInfoTitleConfig;
    personalInfoMemberTitle = PersonalInfoMemberTitle;
    phoneRequired:boolean;
    middleNameRequired:boolean;
    dateOfBirthRequired:boolean;
    @Output() getPersonalInfo = new EventEmitter<any>();

    @Output() personalInfoFormStatus = new EventEmitter<any>();

    @Output() verifyEmailAccountStatus = new EventEmitter<boolean>();

    @Output() getReturningGuestUserInfo = new EventEmitter<any>();

    @Input() storeInfo;
    @Input() personalInfo: PersonalInformation;
    @Output() emailAlreadyExists = new EventEmitter<boolean>();
    @Input() retuningGuestUser: Member;
    @Input() isNewFPCEnrollment: boolean;
    // ViewChild Attrbutes
    @ViewChild('personalInfoFormBtn') personalInfoFormBtn: ElementRef;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    controlDisabled: boolean = false;
    checkoutConfig: any;

    constructor(
        private _enrollmentMessageService: EnrollmentMessageService,
        private _formBuilder: FormBuilder,
        private _commonService: CommonService,
        private _maskPipe: MaskPipe,
        private _enrollService: EnrollService,
        private _personalInfoConfigService: PersonalInfoConfigService,
        private _personalInfoTitleService: PersonalInfoTitleConfigService,
        private _messageService: MessageService,
        private _checkoutConfigService : CheckoutConfigService

        
    ) {
    }

    ngOnInit() {
        this.loadDefaultSettings();
    }

    /**
    * @description it used to load default configuration
    * of the current component based on user
    * @date 2018-07-19
    * @private
    * @memberof PersonalInfoComponent
    */
    private loadDefaultSettings(): void {
        if (this.storeInfo) {
            this.getFormValidationsJSON();
            this.getDates();
            this.personalInfoConfig = this._personalInfoConfigService.getSettings(this.storeInfo.homeIsocodeThree);
            this.personalInfoTitleConfig =this._personalInfoTitleService.getSettings(this.storeInfo.homeIsocodeThree);
            this.checkoutConfig = this._checkoutConfigService.getSettings(this.storeInfo.homeIsocodeThree,null);
            this.getContactTypes();
            if (this.personalInfoConfig.enableDOBForFPCEnrollment && this.isNewFPCEnrollment) {
                this.enableDOBField = true;
            }
            this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.storeInfo.homeIsocodeThree);
        } else {
            this.createPersonalInfoForm();
        }
        this.setDefaultPickerDate();
    }

    getContactTypes(): void {
        if(!this.checkoutConfig.removeMobileField && !this.checkoutConfig.removePhoneField){
        this.contactTypes = ContactTypeConstants.phoneTypes;
        this.controlDisabled = false;
      }else if(this.checkoutConfig.removeMobileField){
        this.contactTypes[0] = ContactTypeConstants.phoneTypes[0];
        this.controlDisabled = true;
      }else if (this.checkoutConfig.removePhoneField){
        this.contactTypes[0] = ContactTypeConstants.phoneTypes[1];
       this.controlDisabled = true;
      }
  }
    getFormValidationsJSON(): void {
        this._commonService.getFormValidationsJSON()
          .subscribe((response: any) => {
            this.getCountrySpecificValidations(response);
          },
          (error) => {
            this.createPersonalInfoForm();
          });
      }
      getDates(): void {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        const date = currentDate.getDate();
        this.maxDate = new Date(year, month, date);
      }

      getCountrySpecificValidations(validations): void {
        if (validations) {
          const filterCountryLevlValidations = validations
            .find(x => x.countryCode.toUpperCase() === this.storeInfo.homeIsocodeThree.toUpperCase());
          if (filterCountryLevlValidations) {
            this.personalInfoFormValidations = filterCountryLevlValidations.validations;
          }
        }
        this.createPersonalInfoForm();
      }

    /**
     * @description creating a form for
     * user information
     * @date 2018-07-19
     * @memberof PersonalInfoComponent
     */
    private createPersonalInfoForm(): void {
        this.personalInformationForm = this._formBuilder.group(
            this.addFieldsBasedOnRetailOrGuest()
        );
        this.subscribePersonalInfoFormChanges();
        this.personalInfoSubject();
        this.rebindPersonalInformation();

    }

    /**
     * @description this metod is used
     *  to rebind personal information from local storage
     * @date 2018-07-21
     * @private
     * @memberof PersonalInfoComponent
     */
    private rebindPersonalInformation(): void {
        if (this.personalInfo) {
            this.personalInformation = this.personalInfo;
            if (this.personalInformation.phoneNumber) {
                if(this.phoneNumberFormat){
                    this.personalInformation.phoneNumber = this._maskPipe
                    .transform(this.personalInformation.phoneNumber, this.phoneNumberFormat);
                }else{
                    this.personalInformation.phoneNumber = this.personalInformation.phoneNumber;
                }
            }
            this.personalInformationForm.patchValue({
                firstName: this.personalInformation.firstName,
                middleName: this.personalInformation.middleName,
                lastName: this.personalInformation.lastName,
                email: this.personalInformation.email,
                phoneNumber: this.personalInformation.phoneNumber,
                phoneType: this.personalInformation.phoneType
            });
            if (this.enableDOBField || (this.personalInfoConfig && this.personalInfoConfig.diaplayDateOfBirth)) {
                let dateOfBirthValue = null;
                if (this.personalInformation && this.personalInformation.dateOfBirth) {
                    dateOfBirthValue = moment(new Date(this.personalInformation.dateOfBirth))
                        .format(DateConstants.DateFormat);
                }
                this.personalInformationForm.patchValue({
                    dateOfBirth: dateOfBirthValue ? moment(dateOfBirthValue, 'DD-MMM-YYYY') : ''
                });
            }

            
            if(this.personalInfoConfig && this.personalInfoConfig.displayTitle){
                let title=null;
                if (this.personalInformation && this.personalInformation.title) {
                    title = this.personalInformation.title;  
                    this.personalInformationForm.patchValue({title});              
                }     
            }
           
            this.mailAlreadyExist = this.personalInformation.mailAlreadyExist;
            this.userInfo = this.retuningGuestUser;
        }
    }

    /**
     * @description this method used
     * subscribe changes of form submit
     * event
     * @date 2018-07-24
     * @private
     * @memberof PersonalInfoComponent
     */
    private personalInfoSubject(): void {
        this.personalInfoSubscription = this
            ._enrollmentMessageService.getSubmitPersonalInfoForm().subscribe(isSubmit => {
                this.submitPersonalInfo();
            });
        this.clearFormSubscription = this
            ._enrollmentMessageService.getClearPersonalInfoForm().subscribe(isSubmit => {
                this.personalInformationForm.reset();
            });
        this.isEmailAlreadyExistsSubscription = this
            ._enrollmentMessageService.getIsEmailAlreadyExists().subscribe(isEmailExists => {
                this.mailAlreadyExist = true;
            });
    }


    /**
     * this function allows to add control to
     * personal information form based on retail
     * @description
     * @date 2018-07-19
     * @returns {ControlsConfig}
     * @memberof PersonalInfoComponent
     */
    private addFieldsBasedOnRetailOrGuest(): ControlsConfig {
        const formControls: ControlsConfig = {
            firstName: ['', [Validators.required,Utils.noEmptyString]],
            lastName: ['', [Validators.required,Utils.noEmptyString]],
            middleName: ['', [Utils.noEmptyString]],
            email: ['', this.getValidations(PersonalInfoFormConstants.EMAIL)],
            phoneNumber: ['', this.addValidationsForForm()],
            phoneType: this.personalInfoTitleConfig.useContactTypeAsPhone ? [ContactTypeValue.PHONE] : [ContactTypeValue.MOBILE],
        };
        if(this.personalInfoFormValidations && this.personalInfoFormValidations[PersonalInfoFormConstants.MIDDLENAME]){
            const formControlName = this.personalInfoFormValidations? this.personalInfoFormValidations[PersonalInfoFormConstants.MIDDLENAME]:{};
            if(formControlName && formControlName.required){
                const requiredMemberType = formControlName.requiredMemberType ? JSON.parse(formControlName.requiredMemberType) : null;
                if (requiredMemberType && requiredMemberType.length > 0) {
                    if (requiredMemberType.includes(this.isNewFPCEnrollment ? MemberTypeEnum.FPC :  MemberTypeEnum.RETAIL)){
                        formControls['middleName'] = ['', [Validators.required, Utils.noEmptyString]];
                        this.middleNameRequired = true;
                    }
                } else {
                    formControls['middleName'] = ['', [Validators.required, Utils.noEmptyString]];
                    this.middleNameRequired = true;
                }  
            }

        } 
        if (this.enableDOBField) {
            formControls['dateOfBirth'] = ['', [Validators.required, ValidateDateOfBirth.DOBFormat]];
            this.dateOfBirthRequired=true;  
        }
        if(this.personalInfoConfig && this.personalInfoConfig.diaplayDateOfBirth){
            formControls['dateOfBirth'] = ['', [ValidateDateOfBirth.DOBFormatValidation]]; 
            this.dateOfBirthRequired=false;  
        }
        if(this.personalInfoConfig && this.personalInfoConfig.displayTitle){
            formControls['title'] = [PersonalInfoMemberTitle.MR,[Validators.required]];

        }
        return formControls;
    }

    addValidationsForForm(): any[] {
        const fieldValidations = [];
        const formControlName = this.personalInfoFormValidations
          ? this.personalInfoFormValidations[PersonalInfoFormConstants.PHONENUMBER]
          : {};
        if (formControlName) {
          if (formControlName[PersonalInfoFormConstants.MINLENGTH]) {
            fieldValidations.push(Validators.minLength(formControlName[PersonalInfoFormConstants.MINLENGTH]));
          }
          if (formControlName[PersonalInfoFormConstants.MAXLENGTH]) {
            fieldValidations.push(Validators.maxLength(formControlName[PersonalInfoFormConstants.MAXLENGTH]));
          }
          if (formControlName[PersonalInfoFormConstants.PATTERN]) {
            fieldValidations.push(Validators.pattern(formControlName[PersonalInfoFormConstants.PATTERN]));
          }
          if(formControlName && formControlName.required){
            fieldValidations.push(Validators.required);
            this.phoneRequired=true;
        }
        }
        return fieldValidations;
    }

    /**
     * @description this method will subscribe
     * the changes for form
     * @date 2019-09-09
     * @private
     * @memberof PersonalInfoComponent
     */
    private subscribePersonalInfoFormChanges(): void {
        this.personalInformationForm
            .valueChanges.
            subscribe(form => {
                if (this.personalInfoFormValidated) {
                    this.personalInfoFormValidated = false;
                }
            });
        this.personalInformationForm
            .statusChanges.
            subscribe(formStatus => {
                this.personalInfoFormValid = formStatus === 'INVALID' ? false : true;
                this.personalInfoFormStatus.emit(this);
            });
    }

    /**
     * @description validates personal information for usa and canada
     * @param fieldName
     */
    private getValidations(fieldName: string): any[] {
        this.personalInfoFormFields = this.personalInfoFormValidations ? this.personalInfoFormValidations
        : CountryLevelValidations.validations;
        const fieldValidations = [];
        const formControlName = this.personalInfoFormFields ? this.personalInfoFormFields[fieldName] : {};
        if (formControlName) {
            if (formControlName[PersonalInfoFormConstants.MINLENGTH]) {
                fieldValidations.push(Validators.minLength(formControlName[PersonalInfoFormConstants.MINLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.MAXLENGTH]) {
                fieldValidations.push(Validators.maxLength(formControlName[PersonalInfoFormConstants.MAXLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.PATTERN]) {
                fieldValidations.push(Validators.pattern(formControlName[PersonalInfoFormConstants.PATTERN]));
            }
        }

        // regular expression which allows only latin characterset including accent marks
        // tslint:disable-next-line:quotemark
        // const nameReg = "^[a-zA-Z0-9~`\\!@#\\$%\\^&*\\(\\)_\\+\\-\\=\\{\\}\\|\"\\:<>\\?,/\\\\.\\[\\];'\\s]*$";
        // if (fieldName === PersonalInfoFormConstants.MIDDLENAME || fieldName === PersonalInfoFormConstants.FIRSTNAME
        //     || fieldName === PersonalInfoFormConstants.LASTNAME || fieldName === PersonalInfoFormConstants.EMAIL) {
        //     fieldValidations.push(Validators.pattern(nameReg));
        // }
        if (fieldName === PersonalInfoFormConstants.FIRSTNAME || fieldName === PersonalInfoFormConstants.LASTNAME
            || fieldName === PersonalInfoFormConstants.EMAIL || fieldName === PersonalInfoFormConstants.PHONENUMBER) {
            fieldValidations.push(Validators.required);
            fieldValidations.push(CustomValidators.requiredNotEmpty);
        }
        return fieldValidations;
    }


    /**
     * validates emailId
     * @param  {any} emailId
     * @param  {boolean} isValid
     * @returns void
     */
    verifyEmailAccountExists(emailId: string, isValid: boolean): void {
        if (isValid) {
            this.emitVerifyEmailAccountStatus(true);
            this.userInfo = null;
            this.isShowLoader = true;
            this._enrollService.verifyEmailAccountExists(emailId)
                .subscribe((verifyAccountResponse: VerifyAccountResponse) => {
                    if(!verifyAccountResponse || (verifyAccountResponse && !verifyAccountResponse.isSuccess)){
                        this.mailAlreadyExist = false;
                        this.isShowLoader = false;
                        this.guestUser = false;
                        this.enrollmentInProgress = false;
                        this.userInfo = null;
                        this.emitVerifyEmailAccountStatus(false);
                        return;
                    }
                    if (verifyAccountResponse.requestStatus === ResponseStatus.COMPLETED
                        || !verifyAccountResponse.requestStatus) {
                        this.isShowLoader = false;
                        this.processVerifyEmailAccountExists(verifyAccountResponse);
                    } else if (verifyAccountResponse.requestStatus === ResponseStatus.QUEUED ||
                        verifyAccountResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        this.processEmailCheckPoll(verifyAccountResponse);
                    }
                }, (err: any) => {
                    this.mailAlreadyExist = false;
                    this.isShowLoader = false;
                    this.guestUser = false;
                    this.enrollmentInProgress = false;
                    this.userInfo = null;
                    this.emitVerifyEmailAccountStatus(false);
                });
        }
    }

    /**
     * @description this method will emit the
     * status of verify account email exists or not
     * @date 2018-08-27
     * @memberof PersonalInfoComponent
     */
    emitVerifyEmailAccountStatus(verifyAccountInProgess: boolean): void {
        this.verifyEmailAccountInProgess = verifyAccountInProgess;
        this.emailAlreadyExists.emit(this.mailAlreadyExist);
        this.verifyEmailAccountStatus.emit(this.verifyEmailAccountInProgess);
    }

    /**
     * @description this method process
     * response of VerifyEmailAccountExists Method
     * @date 2018-07-19
     * @memberof PersonalInfoComponent
     */
    private processVerifyEmailAccountExists(verifyAccountResponse: VerifyAccountResponse): void {
        this.isLegacyUser = false;
        if (verifyAccountResponse) {
            if (!verifyAccountResponse.distributorId && verifyAccountResponse.memberId) {
                this.mailAlreadyExist = false;
                this.enrollmentInProgress = true;
                if(verifyAccountResponse.memberTypeId === MemberTypeEnum.GUEST) {
                 this.guestUser = true;
                }
                else{
                    this.guestUser = false;
                }
                this.userInfo = null;
             } 
             else if (verifyAccountResponse.memberTypeId === MemberTypeEnum.GUEST && verifyAccountResponse.external) {
                this.mailAlreadyExist = false;
                this.guestUser = true;
                this.enrollmentInProgress = false;
                this.externalEmail = true;
                this.externalFboId = verifyAccountResponse.distributorId;
            }
            else if (verifyAccountResponse.memberTypeId === MemberTypeEnum.GUEST && !this.isNewFPCEnrollment) {
                this.mailAlreadyExist = false;
                this.enrollmentInProgress = false;
                this.guestUser = true;
                this.userInfo = this._enrollService.mapAccountResponseToUserInfo(verifyAccountResponse);
                this.getReturningGuestUserInfo.emit(this.userInfo);
            } else if (verifyAccountResponse.distributorId && !verifyAccountResponse.memberId) {
                this.mailAlreadyExist = true;
                this.enrollmentInProgress = false;
                this.guestUser = false;
                this.isLegacyUser = true;
                this.userInfo = null;
            } else {
                this.userInfo = null;
                this.mailAlreadyExist = true;
                this.enrollmentInProgress = false;
                this.guestUser = false;
            }
            this.emitVerifyEmailAccountStatus(false);
            if (verifyAccountResponse.memberPreferences && verifyAccountResponse.memberPreferences) {
                verifyAccountResponse.memberPreferences.forEach((element) => {
                    if (element && element.preferenceId && element.preferenceId === ContactPreferenceType.Email) {
                        const privacyPreference = element.preferenceValue === MemeberCommunicationPreferenceValue.YES + '' ? false : true;
                        this._messageService.setExistingPrivacyPreference(privacyPreference);
                    };
                });

            }

        } else {
            this.userInfo = null;
            this.mailAlreadyExist = false;
            this.enrollmentInProgress = false;
            this.guestUser = false;
            this.emitVerifyEmailAccountStatus(false);
        }
    }

    /**
     * @description this method will subscribe changes
     * when we need to submit guest info
     * @date 2018-07-24
     * @memberof PersonalInfoComponent
     */
    submitPersonalInfo(): void {
        // submiting personal information
        if (this.personalInfoFormBtn
            && !this.personalInfoFormValidated) {
            this.personalInfoFormBtn.nativeElement.click();
        }
    }

    /**
     * remove phone format
     * @param  {any} personalInfoForm
     * @param  {boolean} isValid
     * @returns void
     */
    savePersonalInfo(personalInformation: PersonalInformation, isValid: boolean): void {
        this.formSubmitted = true;
        personalInformation = this._commonService.trimObjectValues(personalInformation);
        if (this.formSubmitted && isValid
            && !this.mailAlreadyExist && !this.isShowLoader) {
            this.personalInformation = personalInformation;
            this.personalInformation.externalEmail = this.externalEmail ? this.externalEmail : this.personalInfo && this.personalInfo.externalEmail ? this.personalInfo.externalEmail : this.externalEmail;
            this.personalInformation.externalFboId = this.externalFboId ? this.externalFboId  : this.personalInfo && this.personalInfo.externalFboId ? this.personalInfo.externalFboId : this.externalFboId;
            this.personalInfoFormValidated = true;
            this.removePhoneFormat();
        } else {
            this.personalInfoFormValidated = false;
            personalInformation.mailAlreadyExist = this.mailAlreadyExist;
            this.personalInformation = personalInformation;
        }
        // emit component information to parent
        if (this.enableDOBField) {
            this.personalInformation.dateOfBirth = this.dateOfBirthFormat(personalInformation.dateOfBirth);
        }
        this.getPersonalInfo.emit(this);
    }

    convertToSpecificDateFormat(dateMomentObj: any) {
        const characterCheck = /[a-zA-z]/;
        const dateInputPattern = /^[a-zA-Z0-9\-]*$/;
        if (dateMomentObj && dateMomentObj.value && (typeof dateMomentObj._i === 'object' || typeof dateMomentObj.value._i === DateConstants.Object)) {
            dateMomentObj = dateMomentObj._d ? dateMomentObj._d : dateMomentObj.value._d;
            this.personalInformationForm.patchValue({
                dateOfBirth: moment(dateMomentObj, 'DD-MMM-YYYY')
            });
            this.datePickerStartDateAt = new Date(dateMomentObj);
        }
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj.value._i === DateConstants.String) {
            dateMomentObj = dateMomentObj.value._i;
            if (dateInputPattern.test(dateMomentObj)) {
                const dateParts = dateMomentObj.split('-');
                if (characterCheck.test(dateParts[1])) {
                    dateMomentObj = moment(dateMomentObj, DateConstants.DateFormat);
                } else {
                    dateMomentObj = moment(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                        .format(DateConstants.DateFormat);
                }
                this.personalInformationForm.patchValue({
                    dateOfBirth: moment(dateMomentObj, DateConstants.DateFormat)
                });
                this.datePickerStartDateAt = new Date(dateMomentObj);
            } else {
                this.datePickerStartDateAt = new Date() ;
            }
        }

    }

    dateOfBirthFormat(dateOfBirth: any) { // getting moment object
        const characterCheck = /[a-zA-z]/;
        if (typeof dateOfBirth._i === DateConstants.Object) {
            dateOfBirth = dateOfBirth._d;
            dateOfBirth = this.momentConstructor(new Date(dateOfBirth)).format(DateConstants.DOBFormat);
        }
        if (typeof dateOfBirth._i === DateConstants.String) {
            dateOfBirth = dateOfBirth._i;
            const dateParts = dateOfBirth.split('-');
            if (characterCheck.test(dateParts[1])) {
                dateOfBirth = moment((dateOfBirth), 'DD-MMM-YYYY')
                    .format(DateConstants.DOBFormat);
            } else {
                dateOfBirth = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                    .format(DateConstants.DOBFormat);
            }
        }
        return dateOfBirth;
    }



    /**
     * @description Saving Checkout Information
     * @date 2019-09-09
     * @memberof PersonalInfoComponent
     */
    private removePhoneFormat(): void {
        if (this.personalInformation.phoneNumber) {
            this.personalInformation.phoneNumber = this.personalInformation.phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        } else {
            this.personalInformation.phoneNumber = null;
        }
    }

    /**
    * validates emailId
    * @param  {any} emailId
    * @param  {boolean} isValid
    * @returns void
    */
    verifyPhoneNumberAccountExists(phoneNumber: string, isValid: boolean): void {
        if (isValid) {
            this.userInfo = null;
            this.isShowPhoneNumberLoader = true;
            this._enrollService.verifyPhoneNumberAccountExists(phoneNumber)
                .subscribe((verifyAccountResponse: boolean) => {
                    this.isShowPhoneNumberLoader = false;
                    this.phoneNumberAlreadyExists = verifyAccountResponse;
                }, (err: any) => {
                    this.isShowPhoneNumberLoader = false;
                    this.phoneNumberAlreadyExists = false;
                });
        }
    }

    /**
     * @description
     * @date 2018-09-17
     * @memberof PersonalInfoComponent
     */
    processEmailCheckPoll(verifyAccountResponse: VerifyAccountResponse) {
        if (this.intialPollCount < this.maxPollCount) {
            this._enrollService.processPollRequest(verifyAccountResponse.location)
                .subscribe(responseObj => {
                    if (responseObj.requestStatus === ResponseStatus.COMPLETED) {
                        this.isShowLoader = false;
                        this.processVerifyEmailAccountExists(responseObj);
                    } else {
                        this.processEmailCheckPoll(responseObj);
                    }
                }, errorResponse => {
                    this.mailAlreadyExist = false;
                    this.enrollmentInProgress = false;
                    this.guestUser = false;
                    this.isShowLoader = false;
                    this.emitVerifyEmailAccountStatus(false);
                    this.getReturningGuestUserInfo.emit(this.userInfo);
                    this._messageService.setExistingPrivacyPreference(true);
                });
        }
    }

    ngOnDestroy(): void {
        if (this.personalInfoSubscription) {
            this.personalInfoSubscription.unsubscribe();
        }
        if (this.clearFormSubscription) {
            this.clearFormSubscription.unsubscribe();
        }
    }

    setDefaultPickerDate(): void {
        const startDate = this.datePickerStartDateAt
            .setFullYear(new Date().getFullYear() - 18);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/enrollment/personal-info.component.ts